export default "__VITE_ASSET__0SDq9yKd__"